/** Claims — edit view (delegates to the shared ClaimForm). */
import { ClaimForm } from "./_ClaimForm";

export function ClaimEdit() {
  return <ClaimForm action="edit" />;
}

export default ClaimEdit;
